export default {
  // '今日'         : {
  //   startDate     : (now) => {
  //     return now;
  //   },
  //   endDate       : (now) => {
  //     return now;
  //   }
  // },

  '一週'   : {
    startDate     : (now) => {
      return now.add(-7, 'days');
    },
    endDate       : (now) => {
      return now;
    }
  },

  '一個月'  : {
    startDate     : (now) => {
      return now.add(-30, 'days');
    },
    endDate       : (now) => {
      return now;
    }
  },
  '三個月'  : {
    startDate     : (now) => {
      return now.add(-90, 'days');
    },
    endDate       : (now) => {
      return now;
    }
  },
  '半年'  : {
    startDate     : (now) => {
      return now.add(-180, 'days');
    },
    endDate       : (now) => {
      return now;
    }
  },
   '一年'  : {
    startDate     : (now) => {
      return now.add(-365, 'days');
    },
    endDate       : (now) => {
      return now;
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/defaultRanges.js